<template>
  <validation-form @on-submit="validateStaffInfos">
    <div id="staff-infos">
      <div class="md-layout">
        <div class="md-layout-item ">
          <md-card v-if="isEditPage" class="w-3/5">
            <md-card-content class="p-4">
              <p class="font-medium text-lg">{{ form.fullName }}</p>
              <p class="font-normal text-base">{{ form.staffCode }}</p>
            </md-card-content>
          </md-card>
          <!--          <div v-if="isEditPage && !isModeSupporter" class="hidden lg:block">
                      <md-card class="rounded-2xl w-[45px] h-[45px]">
                        <md-button
                          class="md-button md-just-icon md-simple"
                          @click="connectChat"
                        >
                          <md-icon>chat</md-icon>
                        </md-button>
                      </md-card>
                    </div>-->
        </div>
        <div class="md-layout-item">
          <Avatar
            :defaultUrl="form.avatarUrl"
            :s3FolderPath="s3FolderPath"
            @on-upload-s3-success="onUploadS3Success"
          />
        </div>
        <div class="md-layout-item"></div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">{{ $t("staff.main_info") }}</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout mt-15">
                <!-- USERNAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.username"
                    :field-class="getValidationClass('username')"
                    name="username"
                  >
                    <label>{{ $t("common.username") }}</label>
                    <md-input
                      v-model.trim="form.username"
                      required
                      :disabled="isEditPage"
                      :maxlength="staffValidations.username.maxLength"
                      autocomplete="off"
                    ></md-input>

                    <span class="md-error" v-if="serverValidations.username">{{
                      serverValidations.username
                    }}</span>
                  </validation-field>
                </div>
                <!-- USERNAME -->

                <!-- PASSWORD -->
                <template v-if="!staffData">
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="staffValidations.password"
                      :field-class="getValidationClass('password')"
                      name="password"
                    >
                      <label>{{ $t("common.password") }}</label>
                      <md-input
                        v-model="form.password"
                        required
                        type="password"
                        :maxlength="staffValidations.password.maxLength"
                        autocomplete="off"
                      ></md-input>
                      <span
                        class="md-error"
                        v-if="serverValidations.password"
                        >{{ serverValidations.password }}</span
                      >
                    </validation-field>
                  </div>
                </template>
                <!-- PASSWORD -->

                <!-- STATUS -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.status"
                    name="status"
                  >
                    <label>{{ $t("common.status") }}</label>
                    <md-select
                      v-model="form.status"
                      name="status"
                      id="status"
                      required
                      :disabled="isReadOnly"
                    >
                      <md-option value="Active"
                        >{{ $t("common.active") }}
                      </md-option>
                      <md-option value="Inactive"
                        >{{ $t("common.inactive") }}
                      </md-option>
                    </md-select>
                  </validation-field>
                </div>
                <!-- STATUS -->

                <!-- FIRSTNAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.first_name"
                    :field-class="getValidationClass('first_name')"
                    name="first name"
                  >
                    <label>{{ $t("common.first_name") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.firstName"
                      required
                      :maxlength="staffValidations.first_name.maxLength"
                    ></md-input>
                    <span
                      class="md-error"
                      v-if="serverValidations.first_name"
                      >{{ serverValidations.first_name }}</span
                    >
                  </validation-field>
                </div>
                <!-- FIRSTNAME -->

                <!-- MIDDLE_NAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.middle_name") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.middleName"
                      :maxlength="staffValidations.middle_name.maxLength"
                    ></md-input>
                  </md-field>
                </div>
                <!-- MIDDLE_NAME -->

                <!-- LASTNAME -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.last_name"
                    :field-class="getValidationClass('last_name')"
                    name="last name"
                  >
                    <label>{{ $t("common.last_name") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.lastName"
                      required
                      :maxlength="staffValidations.last_name.maxLength"
                    ></md-input>
                    <span class="md-error" v-if="serverValidations.last_name">{{
                      serverValidations.last_name
                    }}</span>
                  </validation-field>
                </div>
                <!-- LASTNAME -->

                <!-- PHONE_NUMBER -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.phone_number"
                    name="phone number"
                  >
                    <!-- <phone-number-input v-model="form.phoneNumber">
                    </phone-number-input> -->
                    <vue-tel-input
                      :inputOptions="{
                        placeholder: this.$t('staff.placeholder_phone_number')
                      }"
                      v-model="form.phoneNumber"
                      :onlyCountries="['vn', 'us']"
                    ></vue-tel-input>
                    <span
                      class="md-error"
                      v-if="serverValidations.phone_number"
                      >{{ serverValidations.phone_number }}</span
                    >
                  </validation-field>
                </div>
                <!-- PHONE_NUMBER -->

                <!-- EMAIL -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.email"
                    :field-class="getValidationClass('email')"
                    name="email"
                  >
                    <label>{{ $t("common.email") }}</label>
                    <md-input
                      v-model="form.email"
                      required
                      :maxlength="staffValidations.email.maxLength"
                      :readonly="isReadOnly"
                    ></md-input>
                    <span class="md-error" v-if="serverValidations.email">{{
                      serverValidations.email
                    }}</span>
                  </validation-field>
                </div>
                <!-- EMAIL -->

                <!-- BIRTHDAY -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.birthday"
                    name="birthday"
                    type="date-picker"
                  >
                    <template #default="{ errors }">
                      <date-picker-custom
                        :label="$t('common.birthday')"
                        v-model="form.birthday"
                      >
                        <span class="md-error">{{ errors[0] }}</span>
                      </date-picker-custom>
                    </template>
                  </validation-field>
                </div>
                <!-- BIRTHDAY -->

                <!-- NATIONALITY -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-autocomplete
                    :readonly="isPermissionReadOnly"
                    v-model="form.nationality"
                    :md-options="NATIONALITIES"
                  >
                    <label>{{ $t("staff.nationality") }}</label>
                  </md-autocomplete>
                </div>
                <!-- NATIONALITY -->

                <!-- MARITAL STATUS -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.marital_status") }}</label>
                    <md-select
                      :disabled="isPermissionReadOnly"
                      v-model="form.maritalStatus"
                      name="marital_status"
                      id="marital_status"
                    >
                      <md-option value="Married"
                        >{{ $t("staff.married") }}
                      </md-option>
                      <md-option value="Single"
                        >{{ $t("staff.single") }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- MARITAL STATUS -->

                <!-- Sex -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.sex") }}</label>
                    <md-select
                      :disabled="isPermissionReadOnly"
                      v-model="form.sex"
                      name="sex"
                      id="sex"
                    >
                      <md-option value="Male">{{ $t("staff.male") }}</md-option>
                      <md-option value="Female"
                        >{{ $t("staff.female") }}
                      </md-option>
                      <md-option value="Other"
                        >{{ $t("staff.other") }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- Sex -->

                <!-- Staff Code -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.staff_code"
                    :field-class="getValidationClass('staff_code')"
                    name="staff_code"
                  >
                    <label>{{ $t("staff.staff_id") }}</label>
                    <md-input
                      v-model="form.staffCode"
                      :maxlength="staffValidations.staff_id.maxLength"
                      :disabled="isReadOnly"
                    ></md-input>
                    <span
                      class="md-error"
                      v-if="serverValidations.staff_code"
                      >{{ serverValidations.staff_code }}</span
                    >
                  </validation-field>
                </div>
                <!-- Staff Code -->

                <!-- ROLES -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="{ required: true }"
                    name="roles"
                  >
                    <label>{{ $t("staff.roles") }}</label>
                    <md-select
                      v-model="form.roleIds"
                      name="roleIds"
                      @md-selected="checkAllowedRole"
                      id="roleIds"
                      required
                      multiple
                      :disabled="isReadOnly"
                    >
                      <md-option
                        v-for="role in rolesSetting"
                        :key="role.id"
                        :value="role.id"
                        >{{ role.name }}
                      </md-option>
                    </md-select>
                  </validation-field>
                </div>
                <!-- ROLES -->

                <!-- Sync -->
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                >
                  <validation-field
                    :validations="{ required: true }"
                    name="field"
                  >
                    <label>{{ $t("staff.sync_in") }}</label>
                    <md-select
                      :disabled="isPermissionReadOnly"
                      v-model="form.syncsIn"
                      name="syncs"
                      id="syncs"
                      required
                      multiple
                    >
                      <md-option value="IGS-LMS">IGS-LMS</md-option>
                      <md-option value="sis">SIS</md-option>
                      <md-option value="edmentum">Edmentum</md-option>
                      <md-option value="agilix">Agilix</md-option>
                    </md-select>
                  </validation-field>
                </div>
                <!-- Sync -->
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="md-layout" v-if="hasAllowedRole">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("staff.assigned_students") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout mt-15">
                <div
                  class="md-layout-item md-size-30 md-small-size-100"
                  v-if="!isRoleTeacherOrCounselor"
                >
                  <student-select-component
                    :studentData="studentData"
                    @filtering="filterStdUsn"
                    @open="getAssignableStudentsSearch"
                    ref="studentSelectRef"
                    @update-selected="form.list_student_assign = $event"
                  ></student-select-component>
                </div>
                <div
                  v-if="form.id"
                  class="md-layout-item md-size-70 md-small-size-100 layout__assigned-student"
                >
                  <span class="assign__student-head"
                    >{{ $t("staff.this_mentor_is_currently_assigned") }}
                    {{
                      form.assignedStudentInformation
                        ? form.assignedStudentInformation.length
                        : "0"
                    }}</span
                  >
                  <span
                    class="assign__student-head"
                    v-if="
                      form.assignedStudentInformation &&
                        form.assignedStudentInformation.length > 1
                    "
                  >
                    {{ $t("staff.students") }}:</span
                  >
                  <span class="assign__student-head" v-else>
                    {{ $t("staff.student") }}:</span
                  >
                  <md-list>
                    <div
                      class="flex-space-between"
                      v-for="(student_assigned,
                      assigned) in form.assignedStudentInformation"
                      :key="assigned"
                    >
                      <span class="num-oder assign__student-item">
                        {{ assigned + 1 }}.</span
                      >
                      <div class="assign__student-name assign__student-item">
                        <span>{{ student_assigned.fullName }}</span> -
                        <span>{{ student_assigned.studentCode }}</span>
                      </div>

                      <md-button
                        v-if="!isRoleTeacherOrCounselor"
                        class="md-simple md-just-icon md-icon-button md-danger"
                        @click.native="deleteStudentAssigned(assigned)"
                      >
                        <md-icon>delete_forever</md-icon>
                      </md-button>
                    </div>
                  </md-list>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("staff.working_information") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <!-- JOB TITLE -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.job_title") }}</label>
                    <md-input
                      v-model="form.jobTitle"
                      :maxlength="staffValidations.job_title.maxLength"
                      :readonly="isReadOnly"
                    ></md-input>
                  </md-field>
                </div>
                <!-- JOB TITLE -->

                <!-- Employment Type -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.employment_type") }}</label>

                    <md-select
                      v-model="form.employmentType"
                      name="employmentType"
                      id="employmentType"
                      :disabled="isReadOnly"
                    >
                      <md-option value="Full time"
                        >{{ $t("staff.full_time") }}
                      </md-option>
                      <md-option value="Part-time"
                        >{{ $t("staff.part_time") }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <!-- Employment Type -->

                <!-- Education -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.education") }}</label>
                    <md-input
                      v-model="form.education"
                      :maxlength="staffValidations.education.maxLength"
                      :readonly="isReadOnly"
                    ></md-input>
                  </md-field>
                </div>
                <!-- Education -->

                <!-- Job experience -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.job_experience") }}</label>
                    <md-input
                      v-model="form.jobExperience"
                      :maxlength="staffValidations.job_experience.maxLength"
                      :readonly="isReadOnly"
                    ></md-input>
                  </md-field>
                </div>
                <!-- Job experience -->

                <!-- Hire date -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field v-if="isReadOnly">
                    <label>{{ $t("staff.hire_date") }}</label>
                    <md-input v-model.trim="form.hireDate" readonly></md-input>
                  </md-field>
                  <date-picker-custom
                    v-else
                    :label="$t('staff.hire_date')"
                    v-model="form.hireDate"
                  >
                    <span class="md-error" v-if="!!invalidReleaseHireDateMsg">{{
                      invalidReleaseHireDateMsg
                    }}</span>
                  </date-picker-custom>
                </div>
                <!-- Hire date -->

                <!-- Release date -->
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field v-if="isReadOnly">
                    <label>{{ $t("staff.resignation_date") }}</label>
                    <md-input
                      v-model.trim="form.releaseDate"
                      readonly
                    ></md-input>
                  </md-field>
                  <date-picker-custom
                    v-else
                    :label="$t('staff.resignation_date')"
                    v-model="form.releaseDate"
                  >
                    <span class="md-error" v-if="!!invalidReleaseHireDateMsg">{{
                      invalidReleaseHireDateMsg
                    }}</span>
                  </date-picker-custom>
                </div>
                <!-- Release date -->
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <!-- CERTIFICATES -->
      <certificates
        ref="certificatesRef"
        :isEditPage="isEditPage"
      ></certificates>
      <!-- CERTIFICATES -->
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">{{ $t("common.address") }}</h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.street") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.street"
                      :maxlength="staffValidations.street.maxLength"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.apartment") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.apartment"
                      :maxlength="staffValidations.apartment.maxLength"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.city") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.city"
                      :maxlength="staffValidations.city.maxLength"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <isis-autocomplete
                    :label="$t('common.country')"
                    v-model="primaryAddress.country.displayValue"
                    :value.sync="primaryAddress.country.value"
                    :options="countryOptions"
                    :refetchOptions="
                      queryObj =>
                        getCountries(
                          primaryAddress.country.value,
                          queryObj.search_key
                        )
                    "
                    :searchKey="primaryAddress.country.searchKey"
                    :fields="primaryAddress.country.fields"
                    fetchOnOpen
                  >
                  </isis-autocomplete>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <isis-autocomplete
                    :label="$t('staff.state')"
                    v-model="primaryAddress.state.displayValue"
                    :value.sync="primaryAddress.state.value"
                    :options="stateOptions"
                    :refetchOptions="
                      queryObj =>
                        getStates(
                          primaryAddress.country.value,
                          queryObj.search_key
                        )
                    "
                    :searchKey="primaryAddress.state.searchKey"
                    :fields="primaryAddress.state.fields"
                    :isDisabled="!primaryAddress.country.value"
                    fetchOnOpen
                  >
                  </isis-autocomplete>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("staff.zip") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model="form.zip"
                      :maxlength="staffValidations.zip.maxLength"
                    ></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title text-lg">
                  {{ $t("staff.emergency_contact") }}
                </h4>
              </div>
            </md-card-header>

            <md-card-content>
              <div
                class="md-layout"
                v-for="(emg, index) in form.emergencies"
                :key="index"
              >
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label>{{ $t("common.name") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model.trim="emg.name"
                      maxlength="100"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="{ format: staffValidations.email.format }"
                    :name="`email ${index}`"
                  >
                    <label>{{ $t("common.email") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model.trim="emg.email"
                      :maxlength="staffValidations.email.maxLength"
                    ></md-input>
                  </validation-field>
                </div>

                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="staffValidations.phone_number"
                    name="phone number"
                  >
                    <label>{{ $t("common.phone_number") }}</label>
                    <md-input
                      :readonly="isPermissionReadOnly"
                      v-model.trim="emg.phoneNumber"
                    ></md-input>
                  </validation-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <md-button class="md-raised" @click="goToPreviousPage"
        >{{ $t("common.cancel") }}
      </md-button>
      <md-button v-if="isShowBtnUpdate" type="submit" class="md-success"
        >{{ $t("common.save") }}
      </md-button>
    </div>
  </validation-form>
</template>

<script>
import { validations } from "@/validations/staffs";
import cloneDeep from "lodash/cloneDeep";
import { convertObj, getId, hasHistory, Message } from "@/helpers/utils";
import { service_names, service_paths } from "@/constants/Services";
import AWSConst from "@/constants/AWS";
import { chat_room_names, staff_router_names } from "@/routes/routes";
import nationalities from "@/helpers/nationalities";
import Avatar from "@/components/Base/Avatar";
import Certificates from "./Certificates/index.vue";
import { All, Staff } from "@/constants/Permissions";
import { mapGetters, mapState } from "vuex";
import { hasValidRole, isDynamicRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";

export default {
  name: "StaffInfosForm",
  props: ["staffData", "serverValidations", "isEditPage"],
  components: {
    Avatar,
    Certificates,
    StudentSelectComponent: () => import("./StudentSelectComponent")
  },
  data() {
    let formData = {
      avatarUrl: null,
      staffCode: null,
      username: null,
      password: null,
      firstName: null,
      middleName: null,
      lastName: null,
      roleIds: [],
      syncsIn: ["sis"],
      status: "Active",
      phoneNumber: "",
      email: null,
      jobTitle: null,
      education: null,
      hireDate: null,
      releaseDate: null,
      employmentType: null,
      assignedStudentUuids: [],
      assignedStudentInformation: [],
      list_student_assign: [],
      jobExperience: null,
      maritalStatus: null,
      sex: null,
      birthday: null,
      nationality: null,
      street: null,
      apartment: null,
      primaryState: null,
      primaryCountry: null,
      city: null,
      zip: null,
      emergencies: [
        {
          name: null,
          email: null,
          phoneNumber: null
        },
        {
          name: null,
          email: null,
          phoneNumber: null
        }
      ],
      certificate: []
    };

    return {
      Role,
      hasValidRole,
      certificates: {},
      form: formData,
      allowedRoleList: ["Counselor", "Teacher"],
      chatPages: chat_room_names.listPage,
      rolesSetting: [],
      roleTeacherId: "",
      delayTime: "",
      studentData: [],
      hasAllowedRole: false,
      NATIONALITIES: nationalities,
      staffValidations: this.initValidation(),
      s3FolderPath: `${AWSConst.S3_USER_UPLOAD_PATH}/avatars`,
      All,
      primaryAddress: {
        country: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "two_code"
          },
          searchKey: "search_key"
        },
        state: {
          value: "",
          displayValue: "",
          fields: {
            text: "name",
            value: "name"
          },
          searchKey: "search_key"
        }
      },
      countryOptions: [],
      stateOptions: []
    };
  },
  computed: {
    fullName() {
      return `${this.form.firstName} ${this.form.middleName || ""} ${
        this.form.lastName
      }`;
    },
    ...mapGetters("user", ["role"]),
    ...mapState("user", ["info"]),
    verifyUser() {
      return getId(this.info) === this.$route.params.id;
    },
    isPermissionReadOnly() {
      return (
        this.isEditPage &&
        !this.$can(Staff.actions.edit, Staff.subject) &&
        !this.verifyUser
      );
    },
    canAdd() {
      return this.$can(Staff.actions.add, Staff.subject);
    },
    isReadOnly() {
      return (
        this.isEditPage &&
        (hasValidRole(this.role, Role.Teacher) ||
          hasValidRole(this.role, Role.Counselor) ||
          (isDynamicRole(this.info, this.role) &&
            !this.$can(Staff.actions.edit, Staff.subject) &&
            !this.verifyUser))
      );
    },
    isRoleTeacherOrCounselor() {
      return hasValidRole(this.role, [Role.Teacher, Role.Counselor]);
    },
    invalidReleaseHireDateMsg() {
      if (!this.form.hireDate || !this.form.releaseDate) {
        return "";
      }

      const hireTime = new Date(this.form.hireDate);
      const releaseTime = new Date(this.form.releaseDate);

      return hireTime > releaseTime
        ? this.$t("staff.hire_time_must_be_less_than_release_time")
        : "";
    },
    isShowBtnUpdate() {
      return (
        (this.isEditPage &&
          (this.$can(Staff.actions.edit, Staff.subject) || this.verifyUser)) ||
        (!this.isEditPage && this.canAdd)
      );
    }
    // ...mapGetters("chat", { isModeSupporter: "isModeSupporterLocal" })
  },
  watch: {
    staffData: function(newVal, _) {
      this.form = cloneDeep(newVal);
      this.form.syncsIn = newVal.syncsIn || [newVal.source];
      if (this.hasAllowedRole) {
        this.$refs.studentSelectRef.setDefaultSelections();
      }
    },
    "form.email": function() {
      this.serverValidations.email && delete this.serverValidations.email;
    },

    "form.phoneNumber": function() {
      this.serverValidations.phone_number &&
        delete this.serverValidations.phone_number;
    },

    "form.username": function() {
      this.serverValidations.username && delete this.serverValidations.username;
    },

    "form.password": function() {
      this.serverValidations.password && delete this.serverValidations.password;
    },

    "form.firstName": function() {
      this.serverValidations.first_name &&
        delete this.serverValidations.first_name;
    },

    "form.lastName": function() {
      this.serverValidations.last_name &&
        delete this.serverValidations.last_name;
    },

    // FIX-ME: staffCode now is replaced by staff_id
    "form.staffCode": function() {
      this.serverValidations.staff_code &&
        delete this.serverValidations.staff_code;
    },

    "primaryAddress.country.displayValue"(newCountry) {
      if (!newCountry) {
        this.primaryAddress.state.displayValue = "";
        this.primaryAddress.state.value = "";
      }
      this.form.primaryCountry = newCountry;
    },

    "primaryAddress.state.displayValue"(newState) {
      this.form.primaryState = newState;
    }
  },
  methods: {
    getCountries(selectedValue, searchKey) {
      return this.$axios
        .get(
          `${service_names.user}/countries`,
          {
            "name__~": searchKey
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.countryOptions = data.data;
        });
    },
    getStates(countryCode, searchKey) {
      return this.$axios
        .get(
          `${service_names.user}/states`,
          {
            country_code: countryCode,
            "name__~": searchKey
          },
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data }) => {
          this.stateOptions = data.data;
        });
    },
    getInitAddress(staffData) {
      this.$axios
        .get(`${service_names.user}/countries`, {
          "name__~": staffData.primaryCountry
        })
        .then(({ data }) => {
          this.primaryAddress.country.displayValue = data?.data[0].name;
          this.primaryAddress.country.value = data?.data[0].two_code;
        });
      this.primaryAddress.state.displayValue = staffData.primaryState;
      this.primaryAddress.state.value = staffData.primaryState;
    },
    async connectChat() {
      const userId = this.$route.params.id;
      let { data } = await this.$axios.post(
        `${service_paths.chat}/direct/users/${userId}`
      );
      const roomIdUser = getId(data);
      const route = this.$router.resolve({
        name: chat_room_names.listPage,
        query: { direct_id: roomIdUser }
      });
      window.open(route.href, "_blank");
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    checkAllowedRole() {
      this.hasAllowedRole = !!this.getSelectedRoleList().find(item =>
        this.allowedRoleList.includes(item ? item.name : "")
      );
    },
    getSelectedRoleList() {
      let roleSettingReduce = this.rolesSetting.reduce(
        (roleSettingObject, role) => {
          roleSettingObject[role.id] = role;
          return roleSettingObject;
        },
        {}
      );
      return this.form.roleIds.map(roleSelectedId => {
        if (roleSelectedId in roleSettingReduce) {
          return { ...roleSelectedId, ...roleSettingReduce[roleSelectedId] };
        }
      });
    },

    initValidation() {
      const pageName = this.$route.name;
      const isEditPage = pageName === staff_router_names.detailPage;

      if (isEditPage) {
        // remove required for password
        const { required, ...resPWValidation } = validations.password;
        validations.password = Object.assign({}, resPWValidation);
      }

      return validations;
    },

    deleteStudentAssigned(index) {
      // this.form.assignedStudentUuids.splice(index, 1);
      this.form.assignedStudentInformation.splice(index, 1);
    },

    filterStdUsn(usnQuery) {
      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.getAssignableStudentsSearch({
          search_key: usnQuery,
          fields: ["full_name", "student_code"],
          limit: 100
        }).then(() => {});
      }, 200);
    },

    getAssignableStudentsSearch(params = { limit: 100 }) {
      return this.$axios
        .get(
          service_paths.students + `/filter`,
          params,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(({ data: resData }) => {
          // get memorized selected when modal is opened
          this.studentData = this.removeAssignedStudentExisted(resData);
          const memorizedSelected = this.$refs.studentSelectRef?.getMemorizedSelected();
          memorizedSelected?.forEach(studentSelected => {
            if (!this.studentData.includes(studentSelected))
              this.studentData.push(studentSelected);
          });
        });
    },

    removeAssignedStudentExisted(resData) {
      let memorizedSelected = [];
      const assignedStudentUuidsList = this.form.assignedStudentInformation;
      if (assignedStudentUuidsList.length) {
        const assignedStudentUuidsMapping = assignedStudentUuidsList.reduce(
          (object, item) => {
            object[item.uuid] = item;
            return object;
          },
          {}
        );
        resData.data.forEach(item => {
          if (!(item.uuid in assignedStudentUuidsMapping)) {
            memorizedSelected.push(item);
          }
        });
        return memorizedSelected;
      }
      return resData.data;
    },

    async getStaffRoles() {
      await this.$axios.get(`${service_paths.staffs}/roles`).then(res => {
        this.rolesSetting = [...res.data];
        this.roleTeacherId =
          this.rolesSetting.find(role => role.name === "Teacher").id || "";
        this.checkAllowedRole();
      });
    },

    getValidationClass(fieldName) {
      return {
        "md-invalid": !!this.serverValidations[fieldName]
      };
    },

    async validateStaffInfos() {
      const scStaffInfo = convertObj.camelCaseToSnakeCase(this.form);

      if (!!this.invalidReleaseHireDateMsg) return;
      //
      await this.$refs.certificatesRef.getFormData();
      this.$nextTick(() => {
        scStaffInfo.certificates = this.$refs.certificatesRef.formattedForm;
        scStaffInfo.source = (scStaffInfo.syncs_in || [])[0] || scStaffInfo.source
        this.$emit("onSubmit", scStaffInfo);
      });
    },

    clearForm() {
      // clear but keep uploaded avatar;
      this.$v.$reset();
      const uploadedAvt = this.form.avatarUrl;
      this.form = {
        ...cloneDeep(this.staffData || initialFormData),
        avatarUrl: uploadedAvt
      };
      this.$router.push({ name: staff_router_names.listPage });
    },

    onUploadS3Success(savedLink) {
      this.form.avatarUrl = savedLink;

      if (this.isEditPage) {
        this.$emit("onSubmit", {
          avatar_url: savedLink,
          updateAvatar: true
        });

        return;
      }

      Message.success(this.$t("common.update_avatar_success"));
    }
  },
  created() {
    this.getStaffRoles();
  }
};
</script>
<style lang="scss" scoped>
input:disabled,
.md-select.md-disabled {
  background: rgba(196, 196, 196, 0.3);
}

.md-card {
  box-shadow: 0px 1px 4px 0px #49494980;

  & ~ .md-card {
    margin-top: 50px;
  }
}

.md-error {
  bottom: -7px !important;
}

.form-actions {
  padding: 30px 0;
  text-align: center;

  & > * ~ * {
    margin-left: 15px;
  }

  .md-button {
    box-shadow: 0px 2px 4px 0px #99999924;
    border-radius: 100px;
  }
}

.md-card-content {
  padding-bottom: 30px;
}

.layout__assigned-student {
  .flex-space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
      height: auto;
    }

    .assign__student-name {
      flex: 2;
    }

    .num-oder {
      width: 30px;
    }
  }

  .assign__student-head {
    color: #242424;
    font-size: 16px;
    font-weight: 500;
  }

  .assign__student-item {
    color: #242424;
    font-weight: 400;
    font-size: 16px;
  }
}
</style>
